import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mb-3 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs leading-4 text-gray-400"
}
const _hoisted_5 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col items-center rounded-md bg-greyLight px-5 py-8 text-center"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col items-center rounded-md bg-greyLight px-5 py-8 text-center"
}
const _hoisted_8 = {
  key: 3,
  class: "space-y-3"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "ml-3 min-w-0 flex-1" }
const _hoisted_11 = { class: "flex items-center justify-between space-x-2" }
const _hoisted_12 = { class: "flex min-w-0 items-baseline space-x-2" }
const _hoisted_13 = { class: "truncate text-sm font-semibold leading-5 text-grey" }
const _hoisted_14 = {
  key: 0,
  class: "shrink-0 text-xs leading-5 text-gray-400"
}
const _hoisted_15 = {
  key: 0,
  class: "shrink-0 rounded-full bg-blue px-2 py-0.5 text-[10px] font-semibold leading-none text-white"
}
const _hoisted_16 = {
  key: 1,
  class: "flex shrink-0 items-center space-x-1 rounded-full bg-green px-2 py-0.5 text-[10px] font-semibold leading-none text-white"
}
const _hoisted_17 = { class: "mt-1 flex items-center space-x-2" }
const _hoisted_18 = { class: "truncate text-xs text-gray-400" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "mt-0.5 truncate text-xs text-gray-400" }
const _hoisted_21 = {
  key: 0,
  class: "border-t border-gray-200 px-4 py-3"
}
const _hoisted_22 = { class: "grid grid-cols-2 gap-y-2 text-xs" }
const _hoisted_23 = { class: "text-right font-medium text-grey" }
const _hoisted_24 = { class: "text-right font-medium text-grey" }
const _hoisted_25 = { class: "text-right font-medium text-grey" }
const _hoisted_26 = { class: "text-right font-medium text-grey" }
const _hoisted_27 = {
  key: 0,
  class: "col-span-2 flex justify-end"
}
const _hoisted_28 = {
  key: 1,
  class: "col-span-2 flex items-start space-x-1.5 text-red"
}
const _hoisted_29 = { class: "text-right font-medium text-grey" }
const _hoisted_30 = {
  key: 0,
  class: "mt-4 flex flex-col space-y-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")!
  const _component_status_modal = _resolveComponent("status-modal")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex h-9 w-9 items-center justify-center rounded-lg bg-yellowLight text-primary" }, [
          _createElementVNode("i", { class: "fas fa-shield-alt" })
        ], -1)),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-sm font-medium leading-5 text-grey" }, " Доверенные устройства ", -1)),
          (_ctx.devices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.devices.length) + " " + _toDisplayString(_ctx.pluralize), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadDevices && _ctx.loadDevices(...args))),
        class: "flex h-9 w-9 items-center justify-center rounded-lg bg-greyLight text-grey active:scale-95",
        "aria-label": 'Обновить список устройств'
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas fa-sync-alt transition-transform duration-300", { 'animate-spin': _ctx.loading }])
        }, null, 2)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "h-[86px] animate-pulse rounded-md bg-gray-200"
            })
          }), 64))
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-exclamation-triangle text-2xl text-red" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-3 text-sm text-grey" }, " Не удалось загрузить список устройств ", -1)),
            _createVNode(_component_button_component, {
              color: "primary",
              rounded: "lg",
              "text-color": "white",
              title: "Повторить",
              height: "10",
              class: "mt-4 w-1/2",
              onClickAction: _ctx.loadDevices
            }, null, 8, ["onClickAction"])
          ]))
        : (!_ctx.devices.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-mobile-alt text-3xl text-gray-300" }, null, -1),
              _createElementVNode("div", { class: "mt-3 text-sm font-medium text-grey" }, " Нет доверенных устройств ", -1),
              _createElementVNode("div", { class: "mt-1 text-xs text-gray-400" }, " Устройства, с которых вы входили в приложение, появятся здесь. ", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: device.id,
                  class: _normalizeClass(["overflow-hidden rounded-md bg-greyLight", 
          device.is_current
            ? 'ring-2 ring-blue'
            : device.has_active_session
            ? 'ring-2 ring-green'
            : ''
        ])
                }, [
                  _createElementVNode("button", {
                    class: "flex w-full items-center px-4 py-3 text-left active:bg-gray-100",
                    onClick: ($event: any) => (_ctx.toggleExpand(device.id))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white", _ctx.platformStyle(device.platform).bg])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.platformStyle(device.platform).icon, "text-lg"])
                      }, null, 2)
                    ], 2),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.platformTitle(device.platform)), 1),
                          (device.app_version && _ctx.isNativePlatform(device))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(device.app_version), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (device.is_current)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("span", { class: "inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white" }, null, -1),
                              _createTextVNode(" Это устройство ", -1)
                            ]))]))
                          : (device.has_active_session)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("span", { class: "inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white" }, null, -1),
                                _createElementVNode("span", null, "Сессия активна", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(device.city_locator ||
                  device.title_locator ||
                  "Местоположение неизвестно"), 1),
                        (device.locator_pending)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              role: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.requestLocation(device)), ["stop"]),
                              class: "shrink-0 cursor-pointer rounded-full bg-blue px-2 py-0.5 text-[10px] font-semibold leading-none text-white active:scale-95"
                            }, " Запросить местоположение ", 8, _hoisted_19))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(device.ip_address || "—") + ", " + _toDisplayString(device.user_agent || "—"), 1)
                    ]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down ml-2 text-gray-400 transition-transform duration-300", { 'rotate-180': _ctx.expandedId === device.id }])
                    }, null, 2)
                  ], 8, _hoisted_9),
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    (_ctx.expandedId === device.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-gray-400" }, "IP-адрес", -1)),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(device.ip_address || "—"), 1),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-gray-400" }, "Браузер", -1)),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(device.user_agent || "—"), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-gray-400" }, "Версия приложения", -1)),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.isNativePlatform(device) ? device.app_version || "—" : _ctx.platformTitle(device.platform)), 1),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-gray-400" }, "Местоположение", -1)),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(device.title_locator || "—"), 1),
                            (device.locator_pending)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createVNode(_component_button_component, {
                                    color: "blue",
                                    rounded: "lg",
                                    "text-color": "white",
                                    title: "Запросить местоположение",
                                    height: "10",
                                    loading: _ctx.requestingLocationId === device.id,
                                    onClickAction: ($event: any) => (_ctx.requestLocation(device))
                                  }, null, 8, ["loading", "onClickAction"])
                                ]))
                              : (!device.city_locator)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "fas fa-exclamation-circle mt-0.5" }, null, -1),
                                    _createElementVNode("span", null, "Точное местоположение определить не удалось", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-span-2 flex items-start space-x-1.5 text-red" }, [
                              _createElementVNode("i", { class: "fas fa-exclamation-circle mt-0.5" }),
                              _createElementVNode("span", null, [
                                _createTextVNode(" Данные о местоположении предоставляет провайдер "),
                                _createElementVNode("br"),
                                _createTextVNode(" (могут отличаться от реальных) ")
                              ])
                            ], -1)),
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-gray-400" }, "Последний вход", -1)),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDate(device.last_seen_at)), 1)
                          ]),
                          (!device.is_current)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (device.has_active_session)
                                  ? (_openBlock(), _createBlock(_component_button_component, {
                                      key: 0,
                                      color: "blue",
                                      rounded: "lg",
                                      "text-color": "white",
                                      title: "Завершить сессию",
                                      height: "10",
                                      loading: _ctx.deauthorizingId === device.id,
                                      onClickAction: ($event: any) => (_ctx.deauthorizeDevice(device))
                                    }, null, 8, ["loading", "onClickAction"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_button_component, {
                                  color: "red",
                                  rounded: "lg",
                                  "text-color": "white",
                                  title: "Отозвать доступ",
                                  height: "10",
                                  loading: _ctx.deletingId === device.id,
                                  onClickAction: ($event: any) => (_ctx.deleteDevice(device))
                                }, null, 8, ["loading", "onClickAction"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_auto_animate, { duration: 250 }]
                  ])
                ], 2))
              }), 128))
            ])),
    _createVNode(_component_status_modal, {
      type: "success",
      state: _ctx.statusModalDialog,
      description: _ctx.statusModalText,
      "button-text": "Ок",
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusModalDialog = false))
    }, null, 8, ["state", "description"])
  ]))
}